export const DRAWERWIDTH = 240;
export const NAVBARHEIGHT = 100;
export const ITEM_HEIGHT = 48;
export const ITEM_PADDING_TOP = 8;
export const ACCESS_LEVELS = ["PUBLIC", "PRIVATE", "PROTECTED"];
export const filterSelectionSx = { m: 1, width: 250 };
export const UNIT_OF_DAY = 24 * 60 * 60 * 1000;